module.exports = "/assets/owl.png";